import { call, put, takeLatest } from "redux-saga/effects";
import apiService from "services/apiservice";
import { getErrorMessageString } from "utils/utils";
import { notificationController } from "components/common/notificationController";
import { loadState } from "library/helpers/sessionStorage";
import {
  fetchPodDocumentUploadDetailsListFailure,
  fetchPodDocumentUploadDetailsListSuccess,
} from "./actions";
import { FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_REQUEST } from "./actionTypes";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const config = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  },
};

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, config);
  return data;
};

function* fetchPodDocumentUploadDetailsListSaga(action: any) {
  try {
    const response: { status: string } = yield call(
      postRequest,
      action.url,
      action.payload,
    );

    yield put(fetchPodDocumentUploadDetailsListSuccess(response));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    if (errorMessage && error?.response?.status !== 401) {
      notificationController.error({
        message: "Error",
        description: `Error fetching activity list: ${errorMessage}`,
      });
    }
    yield put(fetchPodDocumentUploadDetailsListFailure(errorMessage));
  }
}

export default function* activitySagas() {
  yield takeLatest(
    FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_REQUEST,
    fetchPodDocumentUploadDetailsListSaga,
  );
}
